import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconsEnum } from '@uigy/generated/icons.enum';
import { DataChipInput } from '@uigy/shared/components/data-chip/interface';
import {
  UiDataChipComponent,
} from '@uigy/shared/components/data-chip/ui-data-chip.component';
import { HeadingComponent } from '@uigy/shared/components/heading/heading.component';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import {
  KpiDrawerInput,
  PillsInput,
  SourceDestination,
} from '@uigy/shared/components/ui-drawer/components/ui-drawer-content-header/interface';
import {
  PillTypes,
} from '@uigy/shared/components/ui-drawer/components/ui-drawer-content-header/ui-drawer-content-header.enums';
import { SeverityPillComponent } from '@uigy/shared/components/ui-severity-pill/severity-pill.component';
import {
  UiStatusPillTypedComponent,
} from '@uigy/shared/components/ui-status-pill/ui-status-pill-typed/ui-status-pill-typed.component';
import { KpiDrawerComponent } from '@uigy/shared/components/widgets/kpi-drawer/kpi-drawer.component';

@Component({
  selector: 'app-ui-drawer-content-header',

  imports: [
    HeadingComponent,
    UiDataChipComponent,
    UiStatusPillTypedComponent,
    SeverityPillComponent,
    IconComponent,
    KpiDrawerComponent,
  ],
  templateUrl: './ui-drawer-content-header.component.html',
  styleUrl: './ui-drawer-content-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiDrawerContentHeaderComponent {

  public title = input.required<string>();
  public pipedTitle = input<string>();
  public topSectionDataChip = input<DataChipInput>();
  public topSectionPills = input<PillsInput[]>();
  public bottomSectionDataChipsTop = input<(DataChipInput)[]>();
  public bottomSourceDestination = input<SourceDestination>();
  public bottomSectionDataChipsBottom = input<DataChipInput[]>();
  public bottomSectionKpiDrawers = input<KpiDrawerInput[]>();

  protected readonly PillTypes = PillTypes;
  protected readonly IconsEnum = IconsEnum;
}
